import { Injectable } from '@visiba/instantiation';
import { ParameterHandler } from '@visiba/std';
import { ApiBaseClient } from './_api_base_client';
import { HttpResponse, HttpService } from '@application/http.service';
import { ReceptionVisitInput } from './generated/clientv2/models';

@Injectable()
export class RecentReceptionsApiService extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super('Receptions');
	}

	public async getRecentlyVisited(count: number): HttpResponse<ReceptionVisitInput[]> {
		const parameterHandler = new ParameterHandler();
		parameterHandler.append({
			count,
		});

		return this.httpService.get(`${this.baseUri}/recentlyVisited${parameterHandler.getString()}`);
	}

	public async postToRecentlyVisited(receptionId: number): HttpResponse<unknown> {
		return this.httpService.post(`${this.baseUri}/recentlyVisited`, { receptionId });
	}
}
